<ng-container *ngIf="arePhoneNumbersLoaded$ | async">
  <ng-container *ngIf="phoneNumbers$ | async; let phoneNumbers">
    <cc-box>

      <div content box>
        <div *ngIf="numbersForPricingExists(phoneNumbers)">
          <div class="numbers-header" translate>ORDER_NUMBER.CHOOSE_NUMBER_HEADER</div>
          <form [formGroup]="filtersForm" class="filters">
            <cc-search-input
              [form]="filtersForm"
              controlName="search"
              placeholder="{{ 'ORDER_NUMBER.TYPE_PREFIX_OR_NAME' | translate}}"
            ></cc-search-input>
          </form>
          <cc-numbers-table
            [numbers]="phoneNumbers"
            (refresh)="refreshNumbers()"
            (chooseNumber)="chooseNumber($event)"
          ></cc-numbers-table>
        </div>

        <cc-empty-numbers
          [pricingId]="pricingId"
          *ngIf="noNumbersForPricing(phoneNumbers)">
        </cc-empty-numbers>
      </div>
    </cc-box>

    <div *ngIf="numbersForPricingExists(phoneNumbers)" class="back-button-wrapper">
      <button
        mat-raised-button
        (click)="back()"
        color="info-full">
        <span translate>BACK</span>
      </button>
    </div>

  </ng-container>
</ng-container>

